import {usePage} from "@inertiajs/react";
import {mix} from "@spa/utils/assetPathResolver";

const Footer = () => {
    const { route, translations, footer } = usePage().props;

    return (
        <footer className="l-f">
            <div className="l-f_wrap">
                <div className="l-f_ver3_cont">
                    <div className="l-f_ver3_link_wrap">
                        <ul>
                            <li>
                                <a href={route.web.browseTop} className="l-f_ver3_link" aria-label={translations.browse_jobs}>
                                    {translations.browse_jobs}
                                </a>
                            </li>
                            <li>
                                <a href={route.web.privacy} className="l-f_ver3_link" aria-label={translations.privacy_policy}>
                                    {translations.privacy_policy}
                                </a>
                            </li>
                            {footer.isDisplayCookiePolicyLink && (
                                <li>
                                    <a href={route.web.cookiePolicy} className="l-f_ver3_link" aria-label={translations.cookie_policy}>
                                        {translations.cookie_policy}
                                    </a>
                                </li>
                            )}
                            {footer.isCookieScriptEnabled && (
                                <li>
                                    <a href="javascript:void(0)" id="csconsentlink" className="l-f_ver3_link" aria-label={translations.cookie_settings}>
                                        {translations.cookie_settings}
                                    </a>
                                </li>
                            )}
                            <li>
                                <a href={route.web.terms} className="l-f_ver3_link" aria-label={translations.terms_of_service}>
                                    {translations.terms_of_service}
                                </a>
                            </li>
                            <li>
                                <a href={route.web.help} className="l-f_ver3_link" aria-label={translations.help_center}>
                                    {translations.help_center}
                                </a>
                            </li>
                            {footer.isDisplayBlogLink && (
                                <li>
                                    <a href="https://jobcube.com/blog/" className="l-f_ver3_link" aria-label={translations.blog}>
                                        {translations.blog}
                                    </a>
                                </li>
                            )}
                            <li>
                                <a href={route.web.about} className="l-f_ver3_link" aria-label={translations.about}>
                                    {translations.about}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="l-f_ver3_media">
                        <a href="https://www.linkedin.com/company/jobcube-com/" className="l-f_ver3_media_btn"
                           target="_blank" rel="noopener">
                            <img src={mix('webfront/images/icon/linkedin.svg')} width="24" height="24" alt="LinkedIn"
                                 loading="lazy"/>
                        </a>
                    </div>
                    <div className="l-f_ver3_bottom">
                        <img src={mix('webfront/images/logo_white.svg')} width="147" height="22" alt="Jobcube" loading="lazy"/>
                        <p className="l-f_copyright"><span>© {new Date().getFullYear()} Jobcube, Inc.</span></p>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
